import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20flowing%20organic%20shapes%2C%20soft%20orange%20and%20cream%20tones%2C%20modern%20minimalist%20design%2C%20smooth%20curves%2C%20inviting%20atmosphere%2C%20clean%20digital%20platform%20background%2C%20no%20text%2C%20elegant%20composition&width=1800&height=600&seq=cta-bg-2026&orientation=landscape')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-accent-500/80"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-background-50">准备好开始了吗？</h2>
        <p className="mt-4 text-base text-background-200 leading-relaxed">
          加入久久在线，随时随地畅享海量优质内容。稳定高速，内容丰富，立即开启您的在线之旅！
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/shipin"
            className="px-8 py-3.5 rounded-full bg-background-50 text-primary-600 font-semibold text-base hover:bg-background-100 transition-all hover:scale-105 whitespace-nowrap"
          >
            立即开始
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border-2 border-background-50/50 text-background-50 font-semibold text-base hover:bg-background-50/15 transition-all whitespace-nowrap"
          >
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}